<template>
  <SogCard>
    <SogCardTitle>
      {{ productTypeName(currentItem.baseProductType) }}
    </SogCardTitle>
    <SogCardContent>
      <SogFlexRow v-show="_hasKzk">
        <SogCard
          v-show="_hasGermany"
        >
          <SogCardTitle>Deutschland</SogCardTitle>
          <SogCardContent>
            <table>
              <tr
                v-for="(row) in kzkButtonsGermany"
                :key="row"
              >
                <td
                  v-for="button in row"
                  :key="button.value"
                >
                  <SogButton
                    v-show="button.visible"
                    style="min-width: 65px"
                    @click="onSelectBaseProduct(button.value)"
                  >
                    {{ button.value.carTypeName }}<br>{{ button.value.validityDay }}
                    <span v-show="button.value.validityDay===1">Tag</span>
                    <span v-show="button.value.validityDay!==1">Tage</span>
                    <br>
                    <SogSvgIcon
                      v-show="button.value.isJustInTime"
                      :icon="mdiWeb"
                    />
                    <SogSvgIcon
                      v-show="button.value.isStore"
                      :icon="mdiStore"
                    />
                    <SogSvgIcon
                      v-show="button.value.isStoreExportBlank"
                      :icon="mdiFileDocument"
                    />
                  </sogbutton>
                </td>
              </tr>
            </table>
          </SogCardContent>
        </SogCard>
        <SogCard v-show="_hasIvk">
          <SogCardTitle>IVK</SogCardTitle>
          <SogCardContent>
            <table>
              <tr
                v-for="(row) in kzkButtonsIvk"
                :key="row"
              >
                <td
                  v-for="button in row"
                  :key="button.value"
                >
                  <SogButton
                    v-show="button.visible"
                    style="min-width: 65px"
                    @click="onSelectBaseProduct(button.value)"
                  >
                    {{ button.value.carTypeName }}<br>{{ button.value.validityDay }}
                    <span v-show="button.value.validityDay===1">Tag</span>
                    <span v-show="button.value.validityDay!==1">Tage</span>
                    <br>
                    <SogSvgIcon
                      v-show="button.value.isJustInTime"
                      :icon="mdiWeb"
                    />
                    <SogSvgIcon
                      v-show="button.value.isStore"
                      :icon="mdiStore"
                    />
                    <SogSvgIcon
                      v-show="button.value.isStoreExportBlank"
                      :icon="mdiFileDocument"
                    />
                  </sogbutton>
                </td>
              </tr>
            </table>
          </SogCardContent>
        </SogCard>
      </SogFlexRow>
      <SogFlexRow
        v-for="(row) in zollButtons"
        v-show="zollButtons.some(t=>t.some(b=>b.visible))"
        :key="row"
        style="  justify-content: left;"
      >
        <SogButton
          v-for="button in row"
          v-show="button.visible"
          :key="button.value"
          style="min-width: 65px"
          @click="onSelectBaseProduct(button.value)"
        >
          {{ button.value.carTypeName }}<br>{{ button.value.validityDay }} Tage
          <br>
          <SogSvgIcon
            v-show="button.value.isJustInTime"
            :icon="mdiWeb"
          />
          <SogSvgIcon
            v-show="button.value.isStore"
            :icon="mdiStore"
          />
          <SogSvgIcon
            v-show="button.value.isStoreExportBlank"
            :icon="mdiFileDocument"
          />
        </SogButton>
      </SogFlexRow>
      <SogFlexRow
        v-for="(row) in tzButtons"
        v-show="tzButtons.some(t=>t.some(b=>b.visible))"
        :key="row"
        style="  justify-content: left;"
      >
        <SogButton
          v-for="button in row"
          v-show="button.visible"
          :key="button.value"
          @click="onSelectBaseProduct(button.value)"
        >
          {{ button.value.carTypeName }}
          <br>
          <SogSvgIcon
            v-show="button.value.isJustInTime"
            :icon="mdiWeb"
          />
          <SogSvgIcon
            v-show="button.value.isStore"
            :icon="mdiStore"
          />
          <SogSvgIcon
            v-show="button.value.isStoreExportBlank"
            :icon="mdiFileDocument"
          />
        </SogButton>
      </SogFlexRow>
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import {ProductType, productTypeName} from "@/shared/model/productType";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import Product from "@/shared/model/product";
import {mdiFileDocument, mdiStore, mdiWeb} from "@mdi/js";
import SogButton from "@/shared/ui/SogButton.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogSvgIcon from "@/shared/ui/SogSvgIcon.vue";
import {ref, watch} from "vue";

const _shoppingCartStore = useShoppingCartStore();
const {currentItem, currentBaseProducts} = storeToRefs(_shoppingCartStore);

function onSelectBaseProduct(product: Product) {
  _shoppingCartStore.setBaseProduct(product);
}

const kzkButtonsGermany = ref([[{visible: false, value: new Product()}]]);
const kzkButtonsIvk = ref([[{visible: false, value: new Product()}]]);
const zollButtons = ref([[{visible: false, value: new Product()}]]);
const tzButtons = ref([[{visible: false, value: new Product()}]]);

const _hasKzk = ref(false)
const _hasGermany = ref(false)
const _hasIvk = ref(false)

watch(currentBaseProducts, () => {
  kzkButtonsGermany.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  kzkButtonsIvk.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  zollButtons.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  tzButtons.value = [
    [
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
      {visible: false, value: new Product()},
    ],
  ];
  _hasKzk.value = false;
  _hasGermany.value = false;
  _hasIvk.value = false;

  if (currentBaseProducts.value) {
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId !== "Germany").map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_validityDay = t_product.validityDay ?? 5
      const t_row = t_validityDay - 1;
      _hasIvk.value = true;
      _hasKzk.value = true;
      kzkButtonsIvk.value[t_row][t_col].visible = true;
      kzkButtonsIvk.value[t_row][t_col].value = t_product;
    })
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Kzk && t.territoryTypeId === "Germany").map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_validityDay = t_product.validityDay ?? 5
      const t_row = t_validityDay - 1;
      _hasGermany.value = true;
      _hasKzk.value = true;

      kzkButtonsGermany.value[t_row][t_col].visible = true;
      kzkButtonsGermany.value[t_row][t_col].value = t_product;
    })

    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Zoll).map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_row = t_product.validityDay == 9 ? 0 : t_product.validityDay == 15 ? 1 : 2;
      zollButtons.value[t_row][t_col].visible = true;
      zollButtons.value[t_row][t_col].value = t_product;
    })
    currentBaseProducts.value?.filter(t => t.productTypeId === ProductType.Tz).map(t_product => {
      const t_col = t_product.carTypeId === "PassengerCar" ? 0 : t_product.carTypeId === "Trailer" ? 2 : t_product.carTypeId === "Truck" ? 1 : 3;
      const t_row = 0;
      tzButtons.value[t_row][t_col].visible = true;
      tzButtons.value[t_row][t_col].value = t_product;
    })

  }
}, {immediate: true})


</script>

<style scoped>
th, td {
  padding: 5px;
}


</style>
